/* global ajaxPath */

import listingFilters from './listing-filter.js';
import $ from 'jquery';

const loadMoreLogos = {
  totalItems: 0,
  currentPage: 1,
  sending: false,
  blockContainer: false,
  totalOffset: 0,
  currentOffset: 10,
  // Logo Specific Params
  screenSize: null,
  alignment: null,
  maxItems: 16,

  // Initialize the function.
  init: (blockContainer) => {
    // return false if our block doesnt exist
    if (!$(blockContainer).length) return false;

    // listing element passed from app.js
    loadMoreLogos.blockContainer = document.querySelector(blockContainer);

    // Get total number of items from Dataset.
    const listingWrapper = loadMoreLogos.blockContainer.querySelector('.listing-wrapper');

    if (listingWrapper) {
      loadMoreLogos.totalItems = listingWrapper.dataset.totalitems;

      // handleClick event with click event listener
      loadMoreLogos.handleClick();

      // handle Window resize
      loadMoreLogos.initScreenSizeAdjust();
    }
  },

  // Click handler
  handleClick: () => {
    const listingWrapper = loadMoreLogos.blockContainer.querySelector('.listing-wrapper');
    const loadMoreButton = loadMoreLogos.blockContainer.querySelector('.load-more-btn');

    // click event
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        loadMoreLogos.currentPage = parseInt(listingWrapper.dataset.currentpage);

        // if (!loadMore.sending && loadMore.currentPage * 3 < loadMore.totalItems) {
        loadMoreLogos.getMorePostsAjax();
        // }
      });
    }
  },

  getMorePostsAjax: (initialize) => {
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');
    const category = listingFilters.blockContainer.querySelector('li.active').dataset.title;

    // Get post type from dataset
    const postType = listingWrapper.dataset.posttype;
    let currentPage = parseInt(listingWrapper.dataset.currentpage);
    if (!initialize) {
      currentPage = Number(currentPage) + 1;
      loadMoreLogos.totalOffset += loadMoreLogos.currentOffset;
    }
    const currentPostList = listingWrapper.getAttribute('data-exclude');
    loadMoreLogos.currentOffset =
      currentPage % 2 === 0 ? loadMoreLogos.maxItems + 1 : loadMoreLogos.maxItems;

    // // Track total offset

    // Set data for AJAX call
    const callData = {
      action: 'load_more_logos',
      post_type: postType,
      offset: loadMoreLogos.totalOffset,
      exclude_posts: currentPostList,
      numberposts: loadMoreLogos.currentOffset,
      category,
    };

    $.ajax({
      url: ajaxPath.admin_path,
      data: callData,
      type: 'POST',
      beforeSend() {
        if (!listingFilters.sending) {
          // Insert loading spinner as visual indication to user.
          // listingContainer.insertAdjacentHTML(
          //   'beforeend',
          //   `<div class="spinner">
          //         <div class="rect1"></div>
          //         <div class="rect2"></div>
          //         <div class="rect3"></div>
          //         <div class="rect4"></div>
          //         <div class="rect5"></div>
          //     </div>`
          // );
          // Set sending state to true.
          listingFilters.sending = true;
        }
      },
      success(response) {
        // Insert query response at bottom of container element.
        listingWrapper.insertAdjacentHTML('beforeend', response);

        // update our element list
        listingFilters.updateElementList(listingWrapper);

        // Increase page count to represent current page of items.
        listingWrapper.dataset.currentpage = currentPage;

        // check if we need our load more button
        const allChildren = listingWrapper.querySelectorAll('.item').length;
        const loadMoreButton = loadMoreLogos.blockContainer.querySelector('.load-more-btn');

        // hide our load more if we need to
        if (parseInt(listingWrapper.dataset.totalitems) <= allChildren) {
          loadMoreButton.classList.add('hide');
        }

        setTimeout(() => {
          Array.from(listingWrapper.children).forEach((child) => child.classList.remove('hide'));
        }, 400);
      },
    });
  },
  initScreenSizeAdjust: () => {
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');

    loadMoreLogos.screenSize = $(window).width();

    if (loadMoreLogos.screenSize > 960) {
      loadMoreLogos.alignment = 'large';
      loadMoreLogos.maxItems = 16;
      loadMoreLogos.currentOffset = 16;

      setTimeout(() => {
        Array.from(listingWrapper.children).forEach((child) => child.classList.remove('hide'));
      }, 400);
    } else if (loadMoreLogos.screenSize > 575) {
      loadMoreLogos.alignment = 'small';
      loadMoreLogos.maxItems = 10;
      loadMoreLogos.currentOffset = 10;

      Array.from(listingWrapper.children).forEach((child) => child.remove());

      loadMoreLogos.getMorePostsAjax(true);
    } else {
      loadMoreLogos.alignment = 'xsmall';
      loadMoreLogos.maxItems = 7;
      loadMoreLogos.currentOffset = 7;

      Array.from(listingWrapper.children).forEach((child) => child.remove());

      loadMoreLogos.getMorePostsAjax(true);
    }

    $(window).on('resize', function () {
      loadMoreLogos.screenSize = $(window).width();

      if (
        (loadMoreLogos.alignment === 'large' || loadMoreLogos.alignment === 'xsmall') &&
        loadMoreLogos.screenSize > 575 &&
        loadMoreLogos.screenSize < 960
      ) {
        loadMoreLogos.alignment = 'small';
        loadMoreLogos.maxItems = 10;

        // Get Toggle Button
        const toggleButton = $('#toggle-button');
        toggleButton.html(`${loadMoreLogos.selectionName} <span class="chevron-down"></span>`);
      } else if (
        (loadMoreLogos.alignment === 'small' || loadMoreLogos.alignment === 'xsmall') &&
        loadMoreLogos.screenSize > 960
      ) {
        loadMoreLogos.alignment = 'large';
        loadMoreLogos.maxItems = 16;
      } else if (
        (loadMoreLogos.alignment === 'small' || loadMoreLogos.alignment === 'large') &&
        loadMoreLogos.screenSize <= 575
      ) {
        loadMoreLogos.alignment = 'xsmall';
        loadMoreLogos.maxItems = 7;
      }
    });
  },
};

export default loadMoreLogos;
